import React from 'react'
import Footer from 'src/Components/shared/Footer'
import FooterText from 'src/Components/shared/FooterText'
import CardPro from 'src/Components/homeowners/CardPro'
import Subscription from 'src/Components/homeowners/Subscription'
import Disclaimer from 'src/Components/homeowners/Disclaimer'
import CompanyDisclaimer from 'src/Components/homeowners/CompanyDisclaimer'
import HousingType from 'src/Components/homeowners/HousingType'

const HomeownerFooter = () => (
  <Footer>
    <CardPro />
    <Subscription />
    <Disclaimer />
    <CompanyDisclaimer />
    <HousingType />
    <FooterText />
  </Footer>
)

export default HomeownerFooter
